import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { BlockSubheader, FeaturesBlock, FeaturesList, FeaturesListItem, IntroBlock, IntroBlockImg } from 'apps/auth/components/common/Layout/MainColumn/styles';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { useThemeDetector } from 'apps/auth/hooks/theme';

import ListAddAccounts from './add/ListAddAccounts';

const EmptyAccountsGA = (props) => {
    const { theme } = useThemeDetector();

    const data = [props.featuresTitleSection2, props.featuresTitleSection3, props.featuresTitleSection4, props.featuresTitleSection5];
    const list = data.map((li, index) => {
        return (
            <FeaturesListItem key={`${li}${index}`}>
                <Icon name="check" color="primary" rightIndent="16px" />
                <span>{li}</span>
            </FeaturesListItem>
        );
    });
    const onClickHandler = (e) => {
        e.preventDefault();
        props.toggleModal(true, <ListAddAccounts />);
    };
    return (
        <>
            <IntroBlock>
                <IntroBlockImg>
                    <img src={`${URL_IMAGES_I}/empty-account${theme === 'dark' ? '-dark' : '-light'}.svg`} alt="empty-account" />
                </IntroBlockImg>
                <Text size={'main'}>{props.featuresTitleSection1}</Text>
            </IntroBlock>
            <Separator />
            <FeaturesBlock>
                <BlockSubheader>{props.featuresTitle}</BlockSubheader>
                <FeaturesList>{list}</FeaturesList>
            </FeaturesBlock>
            <FixedBottomPanel fullwidth isPressedAboveMenu isRightAligned>
                <Button type="button" onClick={onClickHandler} raised={true} size="fit" caption={props.getAccounts} />
            </FixedBottomPanel>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        getAccounts: state.messages.pageMessages.getAccounts,
        featuresTitle: state.messages.pageMessages.featuresTitle,
        featuresTitleSection1: state.messages.pageMessages.featuresTitleSection1,
        featuresTitleSection2: state.messages.pageMessages.featuresTitleSection2,
        featuresTitleSection3: state.messages.pageMessages.featuresTitleSection3,
        featuresTitleSection4: state.messages.pageMessages.featuresTitleSection4,
        featuresTitleSection5: state.messages.pageMessages.featuresTitleSection5,
    };
};
EmptyAccountsGA.propTypes = {
    getAccounts: PropTypes.string.isRequired,
    featuresTitle: PropTypes.string.isRequired,
    featuresTitleSection1: PropTypes.string.isRequired,
    featuresTitleSection2: PropTypes.string.isRequired,
    featuresTitleSection3: PropTypes.string.isRequired,
    featuresTitleSection4: PropTypes.string.isRequired,
    featuresTitleSection5: PropTypes.string.isRequired,
};
export default connect(mapStateToProps, { toggleModal })(EmptyAccountsGA);
